import React from 'react'
import styled from 'styled-components'
import Container from '../Components/Container'
import Title from '../Components/Title'

const Contact = props => {
  return (
    <Container>
      <Wrapper>
        <Title>Contact Me</Title>
        <p>Email: dimashin9@gmail.com</p>
        <p>Phone Number: +1 (647) 554 9993</p>
      </Wrapper>
    </Container>
  )
}

const Wrapper = styled.div`
  margin-top: 40px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  p {
    color: #ffffff;
    font-size: 20px;
  }
`

export default Contact
